import { withErrorBoundary } from "components/fallback/withErrorBoundary";
import { format } from "date-fns";
import { Item } from "elements/Item";
import React, { memo } from "react";
import { INVOICED_PAYMENT_STATUSES } from "utils/constants";

const billPaymentStatus = (
  bill: InvoiceSummaryAttribute,
): { verb: string; type: string; status: string } => {
  const paymentDatePassed = new Date() > new Date(bill?.payment_due_date);

  if (
    paymentDatePassed &&
    [INVOICED_PAYMENT_STATUSES.pastDue, INVOICED_PAYMENT_STATUSES.due].includes(
      bill.payment_status,
    )
  ) {
    return {
      verb: "Overdue from",
      type: "alert",
      status: "Overdue",
    };
  }

  if (bill.payment_status === INVOICED_PAYMENT_STATUSES.due) {
    return { verb: "Paying on", type: "warning", status: "Due" };
  }

  if (bill.payment_status === INVOICED_PAYMENT_STATUSES.complete) {
    return { verb: "Paid on", type: "success", status: "Paid" };
  }

  return { verb: "", type: "", status: "" };
};

type BillItemProps = {
  bill: InvoiceSummaryAttribute;
};

export const BillItemContent: React.FC<BillItemProps> = memo(({ bill }) => {
  const periodStart = bill?.billing_period?.period_started_at
    ? new Date(bill.billing_period.period_started_at)
    : undefined;
  const periodEnd = bill?.billing_period?.period_ended_at
    ? new Date(bill.billing_period.period_ended_at)
    : undefined;
  const amount = bill?.total_payment_due?.price;
  const itemLabel =
    periodStart && periodEnd
      ? `${format(periodStart, "d MMMM")} — ${format(periodEnd, "d MMMM")}`
      : "";

  const paymentStatusDetails = billPaymentStatus(bill);
  const labelNote =
    paymentStatusDetails?.status === "Due"
      ? `${paymentStatusDetails?.verb} ${format(new Date(bill.payment_due_date), "EEE d MMM")}`
      : `Invoice Number: ${bill.number}`;

  return (
    <Item
      href={`/bills/${bill.number}`}
      label={itemLabel}
      labelNote={labelNote}
      value={amount}
      /** valueNote prop is commented out for now - Need to hide the payment status display invoice_timeline does not give us the correct status of the invoice. API work required to fix this issue. */
      // valueNote={paymentStatusDetails.status}

      /** statusDetails prop is commented out for now - Turned off for now as invoice_timeline does not give us the correct status of the invoice. Attributes in paymentStatusDetails are used to determine the color of the text for valueNote and if the coloured border is displayed on the left side of the item by adding the appropriate classes the the div wrapper based on the paymentStatusDetails.type. Turned off for now as the status is not correct.*/
      //statusDetails={paymentStatusDetails}
    />
  );
});

export const BillItem = withErrorBoundary<BillItemProps>(memo(BillItemContent));
